import { ActionsJobs } from "./ActionsJobs";
import { callWebUtils } from "../../Components/CampaignMembers/helpers";

export const ActionsListenersJobs = () => {
  ActionsJobs.getJobs.listen(function (orgaId) {
    return callWebUtils(this, "getJobs", [orgaId]);
  });

  // TODO: Right now onlyfy data only
  ActionsJobs.fetchAndSaveJobs.listen(function (orgaId) {
    return callWebUtils(this, "fetchAndSaveJobs", [orgaId]);
  });

  ActionsJobs.createCampaignBasedOnJob.listen(function (jobId) {
    return callWebUtils(this, "createCampaignBasedOnJob", [jobId]);
  });
};
